/**
 * @generated SignedSource<<17dc01acfec5e79810c8aa81c3dac876>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sideNavBottomLinksFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpModalFragment" | "profileMenuFragment">;
  readonly " $fragmentType": "sideNavBottomLinksFragment";
};
export type sideNavBottomLinksFragment$key = {
  readonly " $data"?: sideNavBottomLinksFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"sideNavBottomLinksFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sideNavBottomLinksFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "helpModalFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "profileMenuFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d10bb970dddbf01f4ce259fa7bf0b3cb";

export default node;
